<div class="slidemenu" #wrap>
    <div class="sm-head" [class.active]="active" (click)="toggle();">{{head}}</div>
    <div class="sm-links">
        <ul>
            <li *ngFor="let p of pages"><a [routerLink]="'/'+currentLang.slug+'/'+  (urlprefix ? urlprefix + '/' : '') +  p.slug" (click)="deactivate();">{{p.name[currentLang.slug]}}</a></li>
        </ul>
    </div>
</div>
